import { CreateGoalTemplate } from '@griply/types';
import { useMutation } from '@tanstack/react-query';
import { createGoalTemplate } from 'shared/services/backend-api';

export const useCreateGoalTemplateMutation = () =>
  useMutation({
    mutationFn: async (template: CreateGoalTemplate) =>
      createGoalTemplate(template),
  });
